import styled from 'styled-components';
import { Layout, Form, Row, Divider } from 'antd';

export const Label = styled.span`
  color: #222222;
`;

export const Image = styled.img`
  width: 100%;
  height: 100vh;
`;

export const FormAntd = styled(Form)`
  padding: 50px 20px;
`;

export const TextFooter = styled.p`
  text-align: center;
  font-size: 14px;
  color: #666666;
  font-weight: bold;
  .v {
    color: #24A95D !important;
    margin-right: 5px;
    font-weight: bold;
  }
  .bold {
    color: #999;
    font-weight: bold;
  }
  .frase {
    color: #999;
    font-weight: bold;
  }
`;

export const RowAntd = styled(Row)`
   {
    padding: 0px 20px;
  }
`;

export const DividerAntd = styled(Divider)`
   {
    padding: 0px !important;
    color: #999 !important;
    font-size: 12px !important;
  }
`;

export const BlockForgot = styled.div`
  display: flex;
  flex-direction: column;
  span {
    padding-bottom: 20px;
    color: #7b7b7b;
  }

  h5 {
    margin: 0;

    span {
      padding: 0;
      padding-right: 7px;
      color: #24A95D;
    }
  }
`;

export const LayoutComp = styled(Layout)`
  background: #001f2a;

  span {
    color: #f1f1f1;
  }

  h5 {
    color: #fff;
  }
`;
